var React = require('react');

function Stroke1Green (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"none","stroke":"#7DB343","strokeWidth":"13","d":"M1503 156s-367 6-591 3c-110-1-214-21-304-50C415 47 228 2-36 7"}));
}

Stroke1Green.defaultProps = {"viewBox":"0 0 1440 167"};

module.exports = Stroke1Green;

Stroke1Green.default = Stroke1Green;
